<div class="flx-modal" role="dialog" aria-modal="true">
    <div class="flx-modal__header">
        <div class="with-desc">
            <h2>{{translate?.general.buttons.choose.singular}} {{translate?.general.messages.aLower}} {{translate?.setup.modules.types.label.singular}}</h2>
        </div>
        <button class="icon-btn" aria-label="Close" (click)="modalRef.hide()">
            <i class="fa-regular fa-xmark"></i>
        </button>
    </div>
    <div class="flx-modal__body"> 
       <div class="selection-list selection-list--bounded" role="listbox" [attr.aria-multiselectable]="false">
            <button
                *ngFor="let opt of jobTypeOptions"
                type="button"
                class="selection-item"
                role="option"
                [attr.aria-selected]="selectedJobType?.id === opt.id"
                [class.is-selected]="selectedJobType?.id === opt.id"
                (click)="nextCreate(opt)">
                <span class="icon" [ngClass]="opt.icon+'-bgColor'">
                <i class="fa-regular {{ opt.icon }}"></i>
                </span>

                <div class="meta">
                <div class="title">{{ opt.name }}</div>
                <div class="desc">{{ opt.description ? opt.description : '-' }}</div>
                </div>
            </button>
        </div>
    </div>

    <div class="flx-modal__footer">
        <p-button type="button" [label]="translate?.general.buttons.new.singular + ' ' + translate?.setup.modules.types.label.singular" styleClass="action" (onClick)="newType()"></p-button>
    </div>
</div>